// extracted by mini-css-extract-plugin
export default {"MapLocationPoint":"MapLocationPoint_MapLocationPoint__ZWhSS","locationPin":"MapLocationPoint_locationPin__+FbWL"};